import React from 'react';
import { SvgIconProps } from '@mui/material';

export const NewCandidatesIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="44"
        height="32"
        viewBox="0 0 44 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M20.6239 20.8544H7.54131C3.92865 20.8544 1 23.783 1 27.3957V30.6664H27.1652V27.3957C27.1652 23.783 24.2366 20.8544 20.6239 20.8544Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        <path
            d="M14.0826 14.3131C17.6953 14.3131 20.6239 11.3844 20.6239 7.77178C20.6239 4.15912 17.6953 1.23047 14.0826 1.23047C10.47 1.23047 7.54131 4.15912 7.54131 7.77178C7.54131 11.3844 10.47 14.3131 14.0826 14.3131Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />

        <path
            d="M33.166 5.31309C33.166 10.2837 37.1955 14.3131 42.166 14.3131C37.1955 14.3131 33.166 18.3425 33.166 23.3131C33.166 18.3425 29.1366 14.3131 24.166 14.3131C29.1366 14.3131 33.166 10.2837 33.166 5.31309Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default NewCandidatesIcon;
